import { AsyncGridColumns, ColumnLink } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.region',
    field: 'name',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.name}</ColumnLink>,
  },
  {
    headerName: 'column.time zone',
    field: 'timezone',
    sortable: false,
    flex: 1,
  },
]
